import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AppSyncGraphqlClient, createAppSyncApolloClient } from './appsync-client.factory';

@Injectable({
  providedIn: 'root'
})
export class MatrixService {
	private readonly client: AppSyncGraphqlClient;

	constructor() {
		this.client = createAppSyncApolloClient({
			url: environment.aws_appsync_matrix,
			region: environment.aws_appsync_region,
			apiKey: environment.aws_appsync_matrix_authentication_value,
		});
	}

	getHydrated(): Promise<AppSyncGraphqlClient> {
		return Promise.resolve(this.client);
	}
}
